import { useRef, useLayoutEffect } from 'react';

export const useScrollLock = (isVisible: boolean, disableScrollLock: boolean) => {
  useLayoutEffect(() => {
    if (isVisible && disableScrollLock) {
      // 1. Capture properties to restore
      const scrollY = window.scrollY;
      const originalPosition = document.body.style.position;
      const originalTop = document.body.style.top;
      const originalLeft = document.body.style.left;
      const originalWidth = document.body.style.width;
      const originalHeight = document.body.style.height;
      const originalBoxSizing = document.body.style.boxSizing;
      const originalOverflow = document.body.style.overflow;
      const originalPaddingRight = document.body.style.paddingRight;

      // 2. Calculate scrollbar width
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

      // 3. Lock the body
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.width = '100%';
      document.body.style.height = 'auto'; // Override global height: 100% to prevent clipping
      document.body.style.boxSizing = 'border-box';
      document.body.style.overflow = 'hidden'; 
      
      // 4. Compensate for scrollbar
      if (scrollBarWidth > 0) {
        document.body.style.paddingRight = `${scrollBarWidth}px`;
        
        // Compensate header if it exists to prevent layout shift
        const header = document.getElementById('app-header');
        if (header) {
          const computedStyle = window.getComputedStyle(header);
          const currentPaddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
          header.style.paddingRight = `${currentPaddingRight + scrollBarWidth}px`;
        }
      }

      return () => {
        // 5. Restore original styles
        document.body.style.position = originalPosition;
        document.body.style.top = originalTop;
        document.body.style.left = originalLeft;
        document.body.style.width = originalWidth;
        document.body.style.height = originalHeight;
        document.body.style.boxSizing = originalBoxSizing;
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
        
        const header = document.getElementById('app-header');
        if (header) {
          header.style.paddingRight = '';
        }
        
        // 6. Restore scroll position
        window.scrollTo(0, scrollY);
      };
    } else {
      return undefined;
    }
  }, [isVisible, disableScrollLock]);
};
